export const getReplyTooltipText = (template: any): string => {
    // Safety here in case something doesn't exist
    if (
        template.replyCount === undefined ||
        template.inProgressCount === undefined ||
        template.finishedCount === undefined ||
        template.cancelledCount === undefined
    ) {
        return '';
    }

    const isSequence = template.emailSequenceTemplateMessages.length > 1;
    const totalSequenceCount =
        template.replyCount +
        template.inProgressCount +
        template.finishedCount +
        template.cancelledCount;

    const singularTitle = isSequence ? 'sequence' : 'email';
    const pluralTitle = isSequence ? 'sequences' : 'emails';

    if (totalSequenceCount === 0 && template.replyCount === 0) {
        return `You’ve never sent this ${singularTitle}`;
    }

    const sequenceString = totalSequenceCount === 1 ? singularTitle : pluralTitle;
    const replyString = template.replyCount === 1 ? 'reply' : 'replies';

    return `${totalSequenceCount} ${sequenceString} sent<br />${template.replyCount} ${replyString} received`;
};

export const getClickTooltipText = (template: any): string => {
    // Safety here in case something doesn't exist
    if (
        template.emailSequenceTemplateMessages === undefined ||
        template.startedWithClickTrackingCount === undefined ||
        template.replyCount === undefined ||
        template.clickCount === undefined
    ) {
        return '';
    }

    const isSequence = template.emailSequenceTemplateMessages.length > 1;
    const totalSequenceCount = template.startedWithClickTrackingCount;

    const singularTitle = isSequence ? 'sequence' : 'email';
    const pluralTitle = isSequence ? 'sequences' : 'emails';

    if (totalSequenceCount === 0 && template.replyCount === 0) {
        // Using replyCount so this tooltip is guaranteed to match the reply tooltip if something is wonky
        return `You’ve never tracked clicks for this ${singularTitle}`;
    }

    const sequenceSentString = totalSequenceCount === 1 ? singularTitle : pluralTitle;
    const sequenceClickedString = template.clickCount === 1 ? singularTitle : pluralTitle;

    return `${totalSequenceCount} ${sequenceSentString} tracked<br />${template.clickCount} ${sequenceClickedString} with clicks`;
};
